import type { Editor } from '@tiptap/react';
import { ALIGNMENT } from '../../../constants';

export const getActiveAlignment = (editor: Editor) => {
  if (editor.isActive({ textAlign: ALIGNMENT.LEFT })) {
    return ALIGNMENT.LEFT;
  }

  if (editor.isActive({ textAlign: ALIGNMENT.CENTER })) {
    return ALIGNMENT.CENTER;
  }

  if (editor.isActive({ textAlign: ALIGNMENT.RIGHT })) {
    return ALIGNMENT.RIGHT;
  }

  return ALIGNMENT.LEFT;
};
